import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { PlaybooksModal } from './components/playbooks-modal';

export const Playbooks2Page: FC = () => {
    const navigate = useNavigate();

    const handleClose = () => {
        // Navigate back to contacts or previous page when closing modal
        navigate('/new/contacts', { replace: true });
    };

    return <PlaybooksModal open={true} onOpenChange={handleClose} />;
};
